<template>
  <div class="">
    <!-- <chat :pushType="pushType" :activityInfo="activityInfo"></chat> -->
    <div><img class="resource-image" @click="isShowResource = true" src="./../img/resource-icon.png" /></div>
    <div class="res-info" v-if="isShowResource" :class="activityInfo.scene === 'ppt' ? 'ppt-top' : 'active-top'">
      <div class="res-head">
        <div>资源</div>
        <div class="resource-delete" @click="isShowResource = false">x</div>
      </div>
      <div class="resource">
        <div v-for="(item, index) of resourceList" class="resource-item" :key="index" @click="goToRes(item)">
          <div class="flex" style="width: 80%">
            <div v-if="item.resType === 'exam'"><img class="resource-icon" src="./../img/exam-icon.png" /></div>
            <div v-if="item.resType === 'attach'"><img class="resource-icon" src="./../img/doc-icon.png" /></div>
            <div v-if="item.resType === 'doc'"><img class="resource-icon" src="./../img/ppt-icon.png" /></div>
            <div class="res-wap">
              <div class="class-title">{{ item.title }}</div>
              <div class="res-time">
                <span v-if="item.createTime">{{ item.createTime | moment('YYYY-MM-DD') }}</span>
              </div>
              <!-- <a-row type="flex" class="margin-bottom-sm" justify="space-between">
                <a-col :span="12">
                  <span v-if="item.createTime" class="text-gray">{{ item.createTime | moment('YYYY-MM-DD') }}</span>
                </a-col>
                <a-col :span="12" class="text-blue text-right">
                  <span v-if="item.resType === 'attach'">去下载 ></span>
                  <span v-if="item.resType === 'exam'">去做题 ></span>
                  <span v-if="item.resType === 'doc'">去查看 ></span>
                </a-col>
              </a-row> -->
            </div>
          </div>
          <div class="res-btn">
            <span v-if="item.resType === 'attach'">下载</span>
            <span v-if="item.resType === 'exam'">做题</span>
            <span v-if="item.resType === 'doc'">下载</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { transformUrl } from '@/utils/util'
// import chat from './chat/chat'
import chat from './plvchat/chat'
export default {
  data() {
    return {
      itemUrls: [],
      scheduleList: [],
      isShowResource: false,
      studentData: {},
    }
  },
  props: {
    pushType: {
      type: String,
      default: '1',
    },
    classesName: {
      type: String,
      default: '1',
    },
    resourceList: {
      type: Array,
      default: () => {
        return []
      },
    },
    activityInfo: {
      type: [String, Object],
      default: '',
    },
  },
  created() {
    this.getSchudelId()
    this.initData()
  },
  computed: {
    ...mapState('course', ['scheduleId', 'planclassesId', 'classesId']),
    otherSchedules() {
      return this.scheduleList.filter((el) => el.id !== this.scheduleId)
    },
    currentSchueules() {
      const filter = this.scheduleList.filter((el) => el.id === this.scheduleId)
      return filter.length > 0 ? filter[0] : null
    },
  },
  methods: {
    initData() {
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
    },
    // 资源列表点击事件
    async goToRes(res, thisPage) {
      console.log('activityInfo', this.activityInfo)
      const restype = res.resType
      switch (restype) {
        case 'doc':
          this.loadHandout(res)
          break
        case 'exam':
          if (thisPage) {
            // let Url =
            //   'exam/l/' + res.id + '/' + this.classesId + '/' + this.planclassesId + '/1'
            // this.examUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Url);
            await this.$http.get(
              `/b/classes/web/stu/schedule/resource/resource/exam/${this.studentData.planclassesId}/${this.studentData.classesId}/${this.studentData.scheduleId}/${res.id}`
            )
          } else {
            this.goToHomeWork(res)
            // window.open('https://lss.51lss.com/exam/e/' + res.id + '/' + this.studentData.classesId + '/' + this.studentData.planclassesId)
          }
          break
        case 'topic':
          // this.clickTopic(res, thisPage);
          break
        case 'video':
          // this.loadVideo(res);
          break
        case 'sand':
          // window.open(res.url);
          break
        case 'attach':
          const item = await this.$http.get(
            `/b/classes/web/stu/schedule/resource/${this.studentData.scheduleId}/${res.id}`
          )
          const url = transformUrl(item.urls[0])
          window.open(url)
          break
        case 'web':
          // window.open(res.urlForWeb);
          break
        case 'audio':
        case 'ebook':
        case 'interview':
          this.reminder()
          break

        default:
      }
    },
    // 解析ppt
    async loadHandout(doc) {
      window.open(doc.url)
      // const res = await this.$http.get(`/b/classes/web/stu/schedule/resource/${this.studentData.scheduleId}/${doc.id}`)
      // if (this.activityInfo.scene === 'ppt') {
      //   const url = transformUrl(res.urls[0])
      //   window.open(url)
      // } else {
      //   this.$emit('analysisPPt', res.urls)
      // }
    },
    getResorce() {
      this.$emit('getResorce')
    },
    callback() {
      console.log('callback')
    },
    async getSchudelId() {
      const params = {
        classesId: this.classesId,
      }
      this.scheduleList = await this.$http.get('/b/classes/web/stu/schedule/listByClassesId', {
        params,
      })
    },
    goToOtherSchedule(item) {
      this.$router.push({
        name: 'watchV2Index',
        query: { scheduleId: item.id, planclassesId: this.planclassesId, classesId: this.classesId },
      })
    },
    goToHomeWork(item) {
      // this.$router.push({
      //   name: 'homeWork',
      //   params: {
      //     classesId: this.studentData.classesId,
      //     planclassesId: this.studentData.planclassesId,
      //     scheduleId: this.studentData.scheduleId,
      //     done: item.done,
      //     examId: item.id,
      //     examName: item.name,
      //     // id: '81e2706b39e57a8c88784e2914651a43', // 试卷id
      //     knowId: item.knowId,
      //     seq: null,
      //   },
      // })
      const routeInfo = this.$router.resolve({
        name: 'homeWork',
        query: {
          classesId: item.classesId || this.studentData.classesId,
          planclassesId: item.planclassesId || this.studentData.planclassesId,
          scheduleId: item.scheduleId || this.studentData.scheduleId,
          done: item.done,
          examId: item.examId,
          examName: item.title,
          id: item.scheduleExamId,
          knowId: item.knowId,
          seq: null,
        },
      })
      window.open(routeInfo.href, '_blank')
    },
  },
  components: {
    chat,
  },
}
</script>
<style scoped lang="less">
.resource {
  overflow: auto;
  // position: absolute;
  // top: 45px;
  // bottom: 0;
  // left: 0;
  // right: 0;
  font-size: 16px;
  height: 700px;
  //height: calc(100% - 100px);
  .class-title {
    color: #333;
    line-height: 20px;
    font-size: 12px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .res-time {
    line-height: 18px;
    font-size: 12px;
    color: #333;
  }
  .resource-item {
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    margin: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    // margin: 6%;
    &:hover {
      cursor: pointer;
    }
  }
  .res-wap {
    padding: 5px 0;
    width: 70%;
  }
}
.text-gray {
  color: #999999;
  font-size: 14px;
}
.text-blue {
  color: #259dd3;
}
/deep/ .ant-tabs-bar {
  border: none;
}
/deep/ .ant-tabs-nav {
  width: 100%;
  color: #666666;
  font-size: 16px;
  div {
    display: flex;
    justify-content: space-around;
  }
  .ant-tabs-tab-active {
    border-bottom: 3px #1890ff solid;
    color: #fff;
  }
  .ant-tabs-tab {
    margin: 0;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 18px;
  }
  .ant-tabs-ink-bar {
    display: none !important;
  }
}
.icon {
  height: 18px;
  width: 18px;
  margin-left: 8px;
}
.course-panel {
  padding: 0 20px;
  color: #999999;
  overflow: auto;
  position: absolute;
  top: 45px;
  bottom: 0;
  left: 0;
  right: 0;
  .title {
    color: #fff;
    font-size: 16px;
    margin-bottom: 14px;
  }
  .panel-item {
    .text {
      margin-left: 12px;
    }
  }
  .item {
    cursor: pointer;
    color: #999999;
    &:first-child {
      margin-top: 0;
    }
    &.select {
      color: #259dd3;
    }
  }
}
.text-white {
  color: #ffffff;
}
.margin-left-sm {
  margin-left: 10px;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.hide-icon {
  visibility: hidden;
}
.text-right {
  text-align: right;
}
.relative {
  position: relative;
}
.res-info {
  position: fixed;
  background-color: #222328;
  right: 0px;
  width: 25%;
  z-index: 9999;
}
.res-head {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #404040;
}
.resource-delete {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.resource-image {
  position: absolute;
  top: 45%;
  right: 10px;
  width: 50px;
  height: 53px;
}
.resource-icon {
  width: 42px;
  height: 42px;
  margin-top: 3px;
}
.res-btn {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 5px;
  border: 1px solid #4b7dfd;
  text-align: center;
  color: #4b7dfd;
  font-size: 12px;
  margin-right: 10px;
}
.res-info.ppt-top {
  top: 42%;
  height: calc(100% - 30%);
}
.res-info.active-top {
  top: 60px;
  height: calc(100% - 60px);
}
</style>
